export default {
  testimonial_supplier: {
    subtitle: "Supplier Stories",

    title1: "What",
    title2: "Suppliers Say",

    desc:
      "Suppliers across regions trust MAHAL to connect with verified restaurants, streamline order management, and grow consistent B2B revenue.",

    cta: "Become a Supplier",

    review:
      "MAHAL has helped us reach more restaurants without the usual operational complexity. Orders are transparent, payments are reliable, and the platform is easy to use.",

    users: [
      {
        name: "Bartholomew",
        role: "Wholesale Supplier",
      },
      {
        name: "Sophie Dennison",
        role: "Food Distributor",
      },
      {
        name: "Israt Jahan",
        role: "Regional Supplier",
      },
    ],
  },
};